class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);


document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const checkoutBtn = document.getElementById("cart-checkout-btn");
      const overlay = document.getElementById("btn-overlay");
      const checkbox1 = document.getElementById("confirm-terms");
      const checkbox2 = document.getElementById("confirm-policy");
      const error1 = document.getElementById("error-terms");
      const error2 = document.getElementById("error-policy");

      if (checkoutBtn && checkbox1 && checkbox2 && overlay && !checkoutBtn.dataset.overlayAttached) {
        checkoutBtn.dataset.overlayAttached = "true";

        const validateCheckboxes = () => {
          const valid1 = checkbox1.checked;
          const valid2 = checkbox2.checked;

          if (valid1) {
            checkbox1.classList.remove("has-error");
            error1.style.display = "none";
          }
          if (valid2) {
            checkbox2.classList.remove("has-error");
            error2.style.display = "none";
          }

          if (valid1 && valid2) {
            checkoutBtn.disabled = false;
            overlay.style.display = "none";
          } else {
            checkoutBtn.disabled = true;
            overlay.style.display = "block";
          }
        };

        checkbox1.addEventListener("change", validateCheckboxes);
        checkbox2.addEventListener("change", validateCheckboxes);

        overlay.addEventListener("click", function (e) {
          e.preventDefault();

          if (!checkbox1.checked) {
            checkbox1.classList.add("has-error");
            error1.style.display = "block";
          }
          if (!checkbox2.checked) {
            checkbox2.classList.add("has-error");
            error2.style.display = "block";
          }
        });

        validateCheckboxes();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });